// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"73916410","553":"b84b8876","844":"53c1b3dc","949":"702fa72f","977":"82c993b3"}[chunkId] + ".chunk.js";
};